const clearCacheStorage = (): Promise<boolean[]> => {
    if (!('caches' in window)) {
        return Promise.resolve([]);
    }

    return caches.keys()
        .then(names =>
            Promise.all(
                names.map(name =>
                    caches.delete(name)
                )
            )
        );
};

const unregisterServiceWorkers = (): Promise<boolean[]> => {
    if (!('serviceWorker' in navigator)) {
        return Promise.resolve([]);
    }

    return navigator.serviceWorker.getRegistrations()
        .then(registrations =>
            Promise.all(
                registrations.map(registration =>
                    registration.unregister()
                )
            )
        );
};

export const clearBrowserCaches = (): Promise<void> =>
    Promise.all([
        clearCacheStorage(),
        unregisterServiceWorkers()
    ])
        .then(() =>
            undefined
        );

export const clearBrowserCachesAndReload = (): void => {
    const reload = (): void => { window.location.reload(); };

    clearBrowserCaches()
        .then(reload)
        .catch(error => {
            console.error(error);
            reload();
        });
};
